import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class ConfirmEmailService {
  constructor(private http: HttpClient) {}

  confirmEmail(email: string): void {
    this.http.post<HttpResponse<null>>('./Api/profile/ConfirmEmail', { Email: email }).pipe(untilDestroyed(this)).subscribe()
  }
}
